import axios from 'axios';

const API_KEY = process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY;
const CALENDAR_ID = process.env.REACT_APP_GOOGLE_CALENDAR_ID;

export const fetchUpcomingEvents = async (maxResults = 10) => {
  try {
    if (!API_KEY || !CALENDAR_ID) {
      console.error('Calendar API configuration missing');
      return [];
    }

    const now = new Date().toISOString();
    const url = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events`;
    
    const response = await axios.get(url, {
      params: {
        key: API_KEY,
        timeMin: now,
        maxResults: maxResults,
        singleEvents: true,
        orderBy: 'startTime',
      },
    });

    return response.data.items || [];
  } catch (error) {
    console.error('Error fetching calendar events:', error.message);
    return [];
  }
};

export const formatEventDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatEventTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
